export default __webpack_public_path__ + "static/media/news_5.21c3eef8.png";